let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // Test: V_SA_LP_04 | Lander Offer Box Shows What Arrives, With Values
  // Replaces the main offer card contents, but Control needs no class: Control is the default card.
  const vSaLp04 = window.igData?.user.getTestGroup("dd1ece4f-b2c8-4b01-93bf-6ac8a70fbfe8");
  if (vSaLp04?.name === "Var A") {
    document.body.classList.add('c-vSaLp04VarA');
  }

  // Test: V_SA_SITE_01 | Price Test: Pocket $79, Classic $99
  // Intelligems sets the prices; the class only tells assets/c-v-sa-site-01.js to sync theme price displays.
  const vSaSite01 = window.igData?.user.getTestGroup("07b4709c-65de-4a03-89f4-3531d2ce2704");
  if (vSaSite01?.name === "Var A") {
    document.body.classList.add('c-vSaSite01VarA');
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
